module.exports = __webpack_public_path__ + "static/media/pincil-price.f57879c7.png";